import { z } from "zod";
export const DTOTransferOwnershipPayload = z.object({
    newOwnerId: z.string(),
});
